import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';

const expectSteps = [
    { num: '1', title: 'You Tell Us Where You Are', body: "Current production volume, team setup, what you've tried, what hasn't worked. No prep needed. Just an honest conversation." },
    { num: '2', title: 'We Diagnose the Gaps', body: "We've seen enough real estate operations to spot the leverage problems quickly. We'll tell you exactly where we think the friction is and what we'd fix first." },
    { num: '3', title: "We Tell You If We're a Fit", body: "If White Glove Hiring makes sense for your situation, we'll explain exactly what it would look like. If it doesn't, we'll tell you that too. No pressure either way." },
];

export function CallSteps() {
    return (
        <section className="bg-white py-24 md:py-32" data-testid="what-to-expect">
            <div className="max-w-4xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="mb-14">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight">
                        Here's What Happens on the Call.
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {expectSteps.map((step, i) => (
                        <motion.div
                            key={step.num}
                            {...staggeredFadeIn(i * 0.1)}
                            className="relative"
                            data-testid={`expect-step-${step.num}`}
                        >
                            <div className="w-10 h-10 rounded-full bg-navy-900 flex items-center justify-center mb-5">
                                <span className="text-gold-400 text-sm font-bold font-inter">{step.num}</span>
                            </div>
                            <h3 className="font-montserrat font-bold text-lg text-navy-900 mb-2">{step.title}</h3>
                            <p className="text-[#6B7280] text-sm leading-relaxed">{step.body}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
